module.exports = __webpack_public_path__ + "img/img15.c3625bc0.png";